import React, { memo, useCallback } from 'react';
import { addFiltersToQuery } from 'site-modules/personalized-search/utils/add-filters-to-query';
import { getQuery } from 'client/utils/location';

export function withLocationUpdate(WrappedComponent) {
  const Component = memo(props => {
    const { onUpdateFilters, ...rest } = props;

    const updateRouteOnNextPaint = useCallback(routeUpdater => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          routeUpdater();
        });
      });
    }, []);

    const handleUpdateFilters = useCallback(
      filters => {
        const query = getQuery(window.location);
        updateRouteOnNextPaint(() => {
          addFiltersToQuery({ pathname: window.location.pathname, query, filters });
        });

        onUpdateFilters?.(filters);
      },
      [onUpdateFilters, updateRouteOnNextPaint]
    );

    return <WrappedComponent {...rest} onUpdateFilters={handleUpdateFilters} />;
  });

  Component.displayName = 'WithLocationUpdate';

  return Component;
}
